/** Kind-aware command service registry for row 2. */

import { openReplaceDialog } from '../../editing/replace-dispatcher.js';
import { capabilitiesForTarget, CONTROL } from './editable-capabilities.js';

const services = new Map();

export function registerElementService(key, service) {
  if (!key || !service || typeof service !== 'object') return false;
  services.set(String(key), service);
  return true;
}

export function serviceFor(target = {}) {
  const key = target.kind || target.editableType || '';
  const registered = services.get(key);
  if (registered) return registered;
  if (capabilitiesForTarget(target).controls.includes(CONTROL.REPLACE)) {
    return {
      replace: () => openReplaceDialog({ target, slots: target.slots || [target] })
    };
  }
  return null;
}

export function registeredServiceTypes() {
  return [...services.keys()].sort();
}
